var _path, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picture",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819",
    "data-name": "Trac\\xE9 9819",
    d: "M18.511,13.122a5,5,0,0,0-7.073,0l-11.4,11.4a8.318,8.318,0,0,0,8.27,7.707H31.641a8.28,8.28,0,0,0,4.587-1.387Z",
    transform: "translate(0.025 7.771)",
    fill: "#717171"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 4.333,
    cy: 4.333,
    r: 4.333,
    transform: "translate(25.667 6.667)",
    fill: "#717171"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_9820",
    "data-name": "Trac\\xE9 9820",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.667,0H8.333A8.343,8.343,0,0,0,0,8.333v19.31l9.107-9.107a8.333,8.333,0,0,1,11.787,0L38.612,36.255A8.282,8.282,0,0,0,40,31.667V8.333A8.343,8.343,0,0,0,31.667,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.335729598999023 2 C 4.846370697021484 2.004180908203125 2.004180908203125 4.846370697021484 2 8.333330154418945 L 2 22.81490707397461 L 7.692268371582031 17.12263107299805 C 9.643819808959961 15.17056083679199 12.2390308380127 14.09537124633789 14.99980926513672 14.0951099395752 C 15.00014686584473 14.0951099395752 15.00047492980957 14.0951099395752 15.00081062316895 14.0951099395752 C 17.76094436645508 14.0951099395752 20.35588836669922 15.1702880859375 22.30754089355469 17.12246131896973 L 37.91047668457031 32.72539901733398 C 37.96978378295898 32.37773513793945 37.99993133544922 32.02382659912109 38 31.66666030883789 L 38 8.335729598999023 C 37.99581909179688 4.846370697021484 35.15362930297852 2.004180908203125 31.66666984558105 2 L 8.335729598999023 2 M 8.333330154418945 0 L 31.66666984558105 0 C 36.26675033569336 0.005512237548828125 39.99449157714844 3.733242034912109 40 8.333330154418945 L 40 31.66666030883789 C 39.99967956542969 33.29953002929688 39.51665878295898 34.89585876464844 38.61166000366211 36.25500106811523 L 20.89332962036133 18.53667068481445 C 17.63879013061523 15.2812614440918 12.36120986938477 15.2812557220459 9.106670379638672 18.53666114807129 L 0 27.64332962036133 L 0 8.333330154418945 C 0.0055084228515625 3.733242034912109 3.733249664306641 0.005512237548828125 8.333330154418945 0 Z",
    stroke: "none",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.eead354442967c8b8369626c22811401.svg";
export { ForwardRef as ReactComponent };